import React from 'react';
import DataTable from '../../../components/DataTable';

const Jobs = () => {

    let columns = [["title", "name"], "vacancies", "institution", "job_status"];
    let headers = ["Name", "Vacancies", "Institution", "Status"]

    return (
        <DataTable
            title="Jobs"
            header={headers}
            filters='fields=id,institution,title,vacancies,description,created_by,job_status'
            url="post-jobs/"
            column={columns}
            view={"/job-detail"}
            edit={false}
        />
    );
};

export default Jobs;